import React from 'react';
import PropTypes from 'prop-types';

export default function PageTitle(props) {
    return (
        <div className="align-items-center justify-content-between mb-4">
            <h1 className="h3 mb-0 text-gray-800">{props.children}</h1>
        </div>
    );
}

PageTitle.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
        PropTypes.string,
    ]),
};
